'use strict';

angular.module('shiftTraderApp')
  .controller('EditProfileVitalsCtrl', function ($scope, Users, $uibModalInstance, SAErrorHandler, toastr,
                                                 params, $timeout, Memberships, UserPermissionsService, regexStrings) {
    $scope.regexStrings = regexStrings;

    $scope.close = function() {
      $uibModalInstance.dismiss(undefined);
    };

    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'users.view_info_in_org',
      'users.update_name',
      'users.update_email_address',
      'memberships.view_external_ids',
      'memberships.change_external_ids'
    ];

    UserPermissionsService.getCanDict(permissionsToLookUp, params.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });

    function processRawPermissions() {
      var rawPerm = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canUpdateEmail: rawPerm['users.update_email_address'],
        canUpdateName: rawPerm['users.update_name'],
        canViewExternalIds: params.org && params.org.organization_config &&
        !!params.org.organization_config.external_id_integration_enabled && rawPerm['memberships.view_external_ids'],
        canUpdateExternalIds: params.org && params.org.organization_config &&
        !!params.org.organization_config.external_id_integration_enabled && rawPerm['memberships.change_external_ids']
      };
    }

    $scope.userFormData = {};
    $scope.userFormData.firstName = params.user.first_name;
    $scope.userFormData.lastName = params.user.last_name;
    $scope.userFormData.email = params.user.email;
    $scope.userFormData.externalId = params.user.$curMemb().external_id;

    if (_.isNull($scope.userFormData.externalId)) {
      $scope.userFormData.externalId = '';
    }

    if (!_.isUndefined(params.focus)) {
      if (params.focus === 'email') {
        $timeout(function() {
          $('input#UserEmail').focus();
        }, 300);
      }
    }

    $scope.emailChanged = function() {
      if ($scope.emailAlreadyTaken) {
        $scope.emailAlreadyTaken = false;
        console.log('emailAlreadyTaken true');
      } else {
        console.log('emailAlreadyTaken false');
      }
    };

    $scope.updateUser = function() {
      //only update if something has actually changed
      if (!($scope.userFormData.firstName === params.user.first_name &&
          $scope.userFormData.lastName === params.user.last_name &&
          $scope.userFormData.externalId === params.user.$curMemb().external_id &&
          ($scope.userFormData.email === params.user.email || (_.isNull(params.user.email) && $scope.userFormData.email === '')))) {
        var data = {
          user: {
            first_name: $scope.userFormData.firstName,
            last_name: $scope.userFormData.lastName,
            email: $scope.userFormData.email
          }
        };
        $scope.requestProcessing = true;
        params.user.$update(data)
          .then(function(ret) {
            $scope.requestProcessing = false;
            console.log('yay! user update went through');
            console.log(ret);


            if ($scope.state.showExternalId) {
              var membData = {
                id: params.user.$curMemb().id,
                external_id: $scope.userFormData.externalId
              };
              $scope.emailAlreadyTaken = false;

              Memberships.update(membData)
                .then(function(respData) {
                  var membIdx = _.findIndex(params.user.memberships, {organization_id: params.org.id});
                  console.log(respData, membIdx);
                  params.user.memberships[membIdx].external_id = respData.external_id;
                  toastr.success('Profile update successful.', 'Success');
                }, function(resp) {
                  toastr.error('We had an issue updating this employee profile. Please try again later.', 'Error');
                });
            } else {
              toastr.success('Profile update successful.', 'Success');
              $scope.emailAlreadyTaken = false;
            }

            $uibModalInstance.close(params.user);
          }, function(response) {
            $scope.requestProcessing = false;
            console.log('boo! we had a problem');
            console.log(response);

            if (_.has(response.data, 'errors')) {
              if (_.has(response.data.errors, 'email')) {
                if (response.data.errors.email[0] === 'has already been taken') {
                  $scope.emailAlreadyTaken = true;
                }
              }
            } else {
              SAErrorHandler.processError(response);
            }
          });
      } else {
        console.log('nothing changed');
        toastr.success('No changes made.', 'Success');
        $uibModalInstance.close(undefined);
      }

    };
  });
